import React, { FunctionComponent, useState } from 'react';
import { ConnectedViewLearners } from 'src/web/containers/InstitutionAdminSettings/LearnersPage/ViewLearners/connector';
import { ConnectedAddMember } from '../components/AddMember/connector';
import { ConnectedRecentlyAddedMembers } from '../components/RecentlyAddedMembers/connector';
import { ConnectedRecentlyAssignedCourses } from '../components/RecentlyAssignedCourses/connector';
import { StyledTabPane, StyledTabs } from '../styles';

enum NavStateEnum {
  VIEW_MEMBER = 'VIEW_MEMBER',
  ADD_MEMBER = 'ADD_MEMBER',
  RECENTLY_ASSIGNED_COURSES = 'RECENTLY_ASSIGNED_COURSES',
  RECENTLY_ADDED_LEARNERS = 'RECENTLY_ADDED_LEARNERS',
}

export const LearnersPage: FunctionComponent = () => {
  const [navState, setNavState] = useState<NavStateEnum>(
    NavStateEnum.VIEW_MEMBER
  );
  return (
    <>
      <StyledTabs
        activeKey={navState}
        destroyInactiveTabPane
        onChange={(key) => setNavState(key as NavStateEnum)}
      >
        <StyledTabPane tab="View learners" key={NavStateEnum.VIEW_MEMBER}>
          <ConnectedViewLearners />
        </StyledTabPane>
        <StyledTabPane tab="Add learners" key={NavStateEnum.ADD_MEMBER}>
          <ConnectedAddMember memberType="learners" />
        </StyledTabPane>
        <StyledTabPane
          tab="Recently added learners"
          key={NavStateEnum.RECENTLY_ADDED_LEARNERS}
        >
          <ConnectedRecentlyAddedMembers memberType="learners" />
        </StyledTabPane>
        <StyledTabPane
          tab="Recently assigned courses"
          key={NavStateEnum.RECENTLY_ASSIGNED_COURSES}
        >
          <ConnectedRecentlyAssignedCourses memberType="learners" />
        </StyledTabPane>
      </StyledTabs>
    </>
  );
};
